module.exports = __webpack_public_path__ + "img/powered-by-light.14732534.svg";